export const FULLY_RESTRICTED_TERRITORIES = [
  'KP', // North Korea
  'IR', // Iran
  'SY', // Syria
  'CU', // Cuba
  'RU', // Russia
  'BY', // Belarus
  'VE', // Venezuela
];

export const DISPUTED_RESTRICTED_TERRITORIES = [
  'XC', // Crimea
  'XD', // Donetsk
  'XL', // Luhansk
  'XZ', // Zaporiyia
  'XK', // Kherson
];

export const ALL_RESTRICTED_TERRITORIES = [
  ...FULLY_RESTRICTED_TERRITORIES,
  ...DISPUTED_RESTRICTED_TERRITORIES,
];

export const isRestrictedTerritory = (countryCode: string | null | undefined): boolean => {
  if (!countryCode) return false;
  return ALL_RESTRICTED_TERRITORIES.includes(countryCode.toUpperCase());
};